export const getYouPayPrice = (variant) => {
    if (variant?.priceDetails?.youPayPrice || variant?.priceDetails?.youPayPrice === 0) {
        return variant?.priceDetails?.youPayPrice;
    }
    return variant?.price;
};
